import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { addToAp } from "../../util/AddToApp";
import Paper from "@material-ui/core/Paper";

class TournamentsInAppContainer extends Component {
  state = {
    tournaments: [],
    tournamentId: "",
    loading: false,
    featuredTournaments: [],
    sort: "date",
    visitors: {},
    loadingVisitors: true,
    refreshTimeout: null,
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("tournamentSearch")
      .where("date", ">=", moment().subtract(3, "days").unix())
      .orderBy("date", "asc")
      .limit(500)
      .onSnapshot((querySnapshot) => {
        let tournaments = [];
        querySnapshot.forEach((doc) => {
          let tournament = doc.data();
          tournament["id"] = doc.id;
          if (tournament.addedOn) {
            tournament["added"] = moment(tournament.addedOn.toDate()).unix();
          }
          tournaments.push(tournament);
        });
        this.setState({ tournaments: tournaments }, () => {
          // Fetch visitor data in batch after tournaments are loaded
          this.fetchVisitorData(tournaments);
        });
      });

    window.firebase
      .firestore()
      .collection("featuredTournaments")
      .doc("ft")
      .onSnapshot((doc) => {
        if (doc.exists) {
          let tournaments = doc.data().ft || [];
          this.setState({ featuredTournaments: tournaments });
        }
      });
  };

  fetchVisitorData = async (tournaments) => {
    if (!tournaments || tournaments.length === 0) {
      this.setState({ loadingVisitors: false });
      return;
    }

    // Clear any existing timeout
    if (this.state.refreshTimeout) {
      clearTimeout(this.state.refreshTimeout);
    }

    // Set a new timeout to debounce rapid requests
    const timeout = setTimeout(async () => {
      try {
        this.setState({ loadingVisitors: true });
        
        // Create batch requests for visitor data
        const batchSize = 10; // Firestore 'in' queries are limited to 10 items
        const visitorData = {};
        
        for (let i = 0; i < tournaments.length; i += batchSize) {
          const batch = tournaments.slice(i, i + batchSize);
          const tournamentIds = batch.map(t => t.id);
          
          const snapshot = await window.firebase
            .firestore()
            .collection("visitors")
            .where(window.firebase.firestore.FieldPath.documentId(), 'in', tournamentIds)
            .get();
          
          snapshot.forEach((doc) => {
            const data = doc.data() || {};
            visitorData[doc.id] = {
              web: data.numVisits || 0,
            };
          });
        }
        
        this.setState({ 
          visitors: visitorData,
          loadingVisitors: false,
          refreshTimeout: null
        });
      } catch (error) {
        console.error("Error fetching visitor data:", error);
        this.setState({ 
          loadingVisitors: false,
          refreshTimeout: null
        });
      }
    }, 300); // 300ms debounce

    this.setState({ refreshTimeout: timeout });
  };

  componentWillUnmount = () => {
    // Clean up timeout to prevent memory leaks
    if (this.state.refreshTimeout) {
      clearTimeout(this.state.refreshTimeout);
    }
  };

  handleToggle = (tournamentId) => {
    let featuredTournaments = this.state.featuredTournaments;
    if (featuredTournaments.indexOf(tournamentId) === -1) {
      // Add tournament to featured list
      featuredTournaments.push(tournamentId);
      
      // Sort featured tournaments by date (earliest first)
      const tournamentData = this.state.tournaments.filter(t => 
        featuredTournaments.includes(t.id)
      );
      const sortedTournamentIds = tournamentData
        .sort((a, b) => a.date - b.date)
        .map(t => t.id);
      
      featuredTournaments = sortedTournamentIds;
    } else {
      // Remove tournament from featured list
      featuredTournaments.splice(featuredTournaments.indexOf(tournamentId), 1);
    }

    window.firebase
      .firestore()
      .collection("featuredTournaments")
      .doc("ft")
      .update({ ft: featuredTournaments });
  };

  generateSearchRecords = () => {
    this.setState({ loading: true });
    addToAp(this.state.tournamentId).then(() => {
      this.setState({ loading: false, tournamentId: "" });
    });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      this.generateSearchRecords(e);
    }
  };

  render() {
    let tournaments = this.state.tournaments.sort((a, b) => {
      if (this.state.sort === "added") {
        return (b.added || 0) - (a.added || 0);
      } else if (this.state.sort === "visitors") {
        const aVisitors = this.state.visitors[a.id]?.web || 0;
        const bVisitors = this.state.visitors[b.id]?.web || 0;
        return bVisitors - aVisitors; // Sort by highest visitors first
      } else {
        return a.date - b.date;
      }
    });
    let featuredTournaments = this.state.featuredTournaments;

    // Sort featured tournaments by date (earliest first)
    const sortedFeaturedTournaments = featuredTournaments
      .map(tournamentId => {
        const tournament = this.state.tournaments.find(t => t.id === tournamentId);
        return tournament ? { id: tournamentId, date: tournament.date } : null;
      })
      .filter(t => t !== null)
      .sort((a, b) => a.date - b.date)
      .map(t => t.id);

    return (
      <div style={{ width: "100%", marginTop: 10 }}>
        <div
          style={{
            display: "flex",
            gap: 10,
            width: "100%",
            justifyContent: "space-evenly",
          }}
        >
          <Paper>
            <div style={{ padding: 15 }}>
              <TextField
                autoFocus
                fullWidth
                margin="normal"
                placeholder="tournamentId"
                value={this.state.tournamentId}
                onKeyDown={this.handleKeyDown}
                onChange={(e) => {
                  this.setState({ tournamentId: e.target.value });
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={this.generateSearchRecords}
                disabled={this.state.loading}
              >
                Add
              </Button>
            </div>
            <div style={{ padding: "0 15px" }}>
              <h3>First 500 upcoming tournaments in app</h3>
            </div>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      cursor: "pointer",
                      fontWeight: this.state.sort === "date" ? 500 : "normal",
                    }}
                    onClick={() => {
                      this.setState({ sort: "date" });
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell style={{ fontWeight: "normal" }}>Name</TableCell>
                  <TableCell 
                    style={{ 
                      cursor: "pointer",
                      fontWeight: this.state.sort === "visitors" ? 500 : "normal",
                    }}
                    onClick={() => {
                      this.setState({ sort: "visitors" });
                    }}
                  >
                    Web visitors
                  </TableCell>
                  <TableCell style={{ fontWeight: "normal" }}>Manage</TableCell>
                  <TableCell style={{ fontWeight: "normal" }}>
                    Add to Featured
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tournaments.map((tournament) => (
                  <TableRow key={tournament.id}>
                    <TableCell>
                      {moment.unix(tournament.date).format("D MMMM YYYY")}
                    </TableCell>

                    <TableCell>{tournament.name}</TableCell>

                    <TableCell>
                      {this.state.loadingVisitors ? (
                        <span style={{ color: '#999', fontStyle: 'italic' }}>Loading...</span>
                      ) : (
                        this.state.visitors[tournament.id]?.web || 0
                      )}
                    </TableCell>

                    <TableCell>
                      <Link
                        to={"/tournament/" + tournament.id}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        checked={
                          featuredTournaments.indexOf(tournament.id) !== -1
                        }
                        onClick={() => {
                          this.handleToggle(tournament.id);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
          <Paper style={{ height: "0%" }}>
            <div style={{ padding: "0 15px" }}>
              <h3>Featured tournaments</h3>
            </div>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      cursor: "pointer",
                      fontWeight: this.state.sort === "date" ? 500 : "normal",
                    }}
                    onClick={() => {
                      this.setState({ sort: "date" });
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell style={{ fontWeight: "normal" }}>Name</TableCell>
                  <TableCell 
                    style={{ 
                      cursor: "pointer",
                      fontWeight: this.state.sort === "visitors" ? 500 : "normal",
                    }}
                    onClick={() => {
                      this.setState({ sort: "visitors" });
                    }}
                  >
                    Web visitors
                  </TableCell>
                  <TableCell style={{ fontWeight: "normal" }}>Manage</TableCell>
                  <TableCell style={{ fontWeight: "normal" }}>
                    Remove
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedFeaturedTournaments.map((tournamentId) => (
                  <FeaturedTournamentRow
                    key={tournamentId}
                    tournamentId={tournamentId}
                    featuredTournaments={this.state.featuredTournaments}
                    handleToggle={this.handleToggle}
                    visitors={this.state.visitors}
                    loadingVisitors={this.state.loadingVisitors}
                  />
                ))}
              </TableBody>
            </Table>
          </Paper>
        </div>
      </div>
    );
  }
}

class FeaturedTournamentRow extends Component {
  state = {
    tournament: {},
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("tournamentSearch")
      .doc(this.props.tournamentId)
      .onSnapshot((doc) => {
        let tournament = doc.data() || {};
        tournament["id"] = doc.id;
        if (tournament.addedOn) {
          tournament["added"] = moment(tournament.addedOn.toDate()).unix();
        }
        this.setState({ tournament: tournament });
      });
  };

  render() {
    const tournament = this.state.tournament;
    return (
      <TableRow>
        <TableCell>
          {moment.unix(tournament.date).format("D MMMM YYYY")}
        </TableCell>

        <TableCell>{tournament.name}</TableCell>

        <TableCell>
          {this.props.loadingVisitors ? (
            <span style={{ color: '#999', fontStyle: 'italic' }}>Loading...</span>
          ) : (
            this.props.visitors[tournament.id]?.web || 0
          )}
        </TableCell>

        <TableCell>
          <Link
            to={"/tournament/" + tournament.id}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open
          </Link>
        </TableCell>
        <TableCell>
          <Checkbox
            checked={
              this.props.featuredTournaments.indexOf(tournament.id) !== -1
            }
            onClick={() => {
              this.props.handleToggle(tournament.id);
            }}
          />
        </TableCell>
      </TableRow>
    );
  }
}

export default TournamentsInAppContainer;
